import React, { Component } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import Link from "@material-ui/core/Link";
import { resourceClick, URL_Click } from "../NonVisual/HLUtil";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
import HLIntervTreeDialog from "../Other/HLIntervTreeDialog";
// import Info from "@material-ui/icons/Info";
// import IconButton from "@material-ui/core/IconButton";
// import TLabel from "../../common/TLabel";
// import TButton from "../../common/TButton";
// import * as GBConst from "../../GB/GBConst";
// import HLDownloadGuideBtn from "../Other/HLDownloadGuideBtn";

class HLStepByStepForm extends Component {
    static propTypes = {
        intervAreaObjList: PropTypes.arrayOf(PropTypes.object),
        intervObjList: PropTypes.arrayOf(PropTypes.object),
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        intervAreaObjList: [],
        intervObjList: [],
        onPageChange: () => console.log("onPageChange"),
    };

    state = {
        showIntervTreeDialog: false,
    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    onShowIntervTreeDialog = () => {
        this.setState({
            showIntervTreeDialog: true,
        });
    };

    onIntervAreaDialogClose = () => {
        this.setState({
            showIntervTreeDialog: false,
        });
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        let textDiv = (
            <div
                style={{
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                    ...Theme.textFontStyle,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                    }}
                >
                    Step-by-step H-LiST approach
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p
                    style={{
                        fontStyle: "italic",
                    }}
                >
                    The H-LiST approach is a seven-step process for prioritizing&nbsp;
                    <Link
                        onClick={this.onShowIntervTreeDialog}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        MNCH, nutrition and WASH interventions
                    </Link>
                    &nbsp;based on which save the most maternal and child lives in a particular context. Click on each
                    step or use the menu to the left to walk through each step.
                </p>

                <ol>
                    <li>
                        <Link
                            onClick={() => this.onPageChange(HLConst.step1Form)}
                            style={{
                                color: Theme.blackColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            Find the <span style={{ fontWeight: "bolder" }}>best match</span> between current coverage
                            and one of the prioritization scale-up scenarios
                        </Link>
                    </li>

                    <li>
                        <Link
                            onClick={() => this.onPageChange(HLConst.step2Form)}
                            style={{
                                color: Theme.blackColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            <span style={{ fontWeight: "bolder" }}>Examine</span> the prioritized interventions for your
                            setting
                        </Link>
                    </li>

                    <li>
                        <Link
                            onClick={() => this.onPageChange(HLConst.step3Form)}
                            style={{
                                color: Theme.blackColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            Identify specific <span style={{ fontWeight: "bolder" }}>incremental activities</span> to
                            scale-up coverage
                        </Link>
                    </li>

                    <li>
                        <Link
                            onClick={() => this.onPageChange(HLConst.step4Form)}
                            style={{
                                color: Theme.blackColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            Estimate the <span style={{ fontWeight: "bolder" }}>incremental cost</span> of those
                            activities
                        </Link>
                    </li>

                    <li>
                        <Link
                            onClick={() => this.onPageChange(HLConst.step5Form)}
                            style={{
                                color: Theme.blackColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            Assess the <span style={{ fontWeight: "bolder" }}>feasibility</span> of improving coverage
                            of each intervention given:
                        </Link>

                        <ul>
                            <li>Cost</li>
                            <li>
                                Implementation-related challenges (e.g. stockouts, personnel) that may prevent you from
                                improving coverage
                            </li>
                        </ul>
                    </li>

                    <li>
                        <Link
                            onClick={() => this.onPageChange(HLConst.step6Form)}
                            style={{
                                color: Theme.blackColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            Make a <span style={{ fontWeight: "bolder" }}>final decision</span> about which
                            interventions and activities to focus on, and add costed activities to your annual plans
                        </Link>
                    </li>

                    <li>
                        <Link
                            onClick={() => this.onPageChange(HLConst.step7Form)}
                            style={{
                                color: Theme.blackColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            <span style={{ fontWeight: "bolder" }}>Monitor</span> coverage levels and adjust activities
                            as necessary
                        </Link>
                    </li>
                </ol>

                <p>
                    You may want to see our&nbsp;
                    <Link
                        onClick={() => resourceClick(HLConst.techNotePDF)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        technical note
                    </Link>
                    ,&nbsp;
                    <Link
                        onClick={() => resourceClick(HLConst.guidanceDocPDF)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        full guidance document
                    </Link>
                    ,&nbsp;
                    <Link
                        onClick={() => resourceClick(HLConst.powerPointPresPDF)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        summary powerpoint presentation
                    </Link>
                    ,&nbsp;
                    <Link
                        onClick={() => resourceClick(HLConst.overviewPDF)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        one page overview
                    </Link>
                    ,&nbsp;
                    <Link
                        onClick={() => URL_Click(HLConst.videoOverview_URL)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        short video overview
                    </Link>
                    , recording of a one hour overview, demonstration and Q&A&nbsp;
                    <Link
                        onClick={() => URL_Click(HLConst.webinar_URL)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        webinar
                    </Link>
                    &nbsp;and&nbsp;
                    <Link
                        onClick={() => resourceClick(HLConst.templatesXLSX)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        H-LiST templates file
                    </Link>
                    &nbsp;before you start to walk through the steps.
                </p>
            </div>
        );

        return textDiv;
    };

    render() {
        const props = this.props;
        const intervAreaObjList = props.intervAreaObjList;
        const intervObjList = props.intervObjList;

        const state = this.state;
        const showIntervTreeDialog = state.showIntervTreeDialog;

        let intervTreeDialog = null;
        if (showIntervTreeDialog) {
            intervTreeDialog = (
                <HLIntervTreeDialog
                    onDialogClose={this.onIntervAreaDialogClose}
                    intervAreaObjList={intervAreaObjList}
                    intervObjList={intervObjList}
                />
            );
        }

        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.introForm)}
                onNextBtnClick={() => this.onPageChange(HLConst.step1Form)}
            />
        );

        return (
            <div
                style={{
                    minHeight: window.innerHeight - Theme.HL_FooterOffset, //Theme.HL_FooterPosition,
                }}
            >
                {this.renderTextDiv()}
                {navBtnDiv}
                {intervTreeDialog}
            </div>
        );
    }
}

export default HLStepByStepForm;
